import React, { useEffect, useState } from "react";
import "./MainDetail.css";
import commenticon from "../../../Component/Images/commenticon.png";
import vector2 from "../../../Component/Images/vector2.png";
import contacticon from "../../../Component/Images/contacticon.png";
import mainimg from "../../../Component/Images/mainimg.png";
import footerimg from "../../../Component/Images/footerimg.png";
import { environmentVariables } from "../../../config/env.config";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { formatDate } from "../../../Component/DateFormat/DateFormat";
import authorimg from "../../../Component/Images/3.png";

const MainDetail = ({ slug }) => {
  const [blogPosts, setBlogPosts] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchBlogsById = async () => {
    try {
      const response = await axios.get(
        `${environmentVariables?.apiUrlBlogs}api/v1/user/get-blog-by-slug?slug=${slug}&type=be`
      );

      if (response?.data?.statusCode === 200) {
        setBlogPosts(response.data.data);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogsById();
  }, [slug]);

  if (loading) {
    return (
      <div style={{ height: "100vh" }}>
        <div id="loader" className="loader"></div>
      </div>
    );
  }
  // const stripHtml = (html) =>
  //   html?.replace(/<[^>]*>/g, '');

  // const keywords = blogPosts?.keyword
  //   ? JSON.parse(blogPosts.keyword).join(', ')
  //   : '';

  /* ================= SEO LOGIC ONLY ================= */

  const stripHtml = (html = "") =>
    html.replace(/<[^>]*>/g, "").trim();

  const keywords = blogPosts?.keyword
    ? JSON.parse(blogPosts.keyword).join(', ')
    : '';

  const baseUrl = environmentVariables?.siteUrl || "https://bastionex.com";

  const metaTitle =
    blogPosts?.meta_title?.trim()
      ? blogPosts.meta_title
      : stripHtml(blogPosts?.heading).slice(0, 60);

  const metaDescription =
    blogPosts?.meta_description?.trim()
      ? blogPosts.meta_description
      : stripHtml(blogPosts?.description).slice(0, 160);

  const canonicalUrl =
    blogPosts?.slug && blogPosts?.type
      ? `${baseUrl}/${blogPosts.type}/blogs/${blogPosts.slug}`
      : baseUrl;

  /* ================= END SEO LOGIC ================= */

  return (
    <div className="MainDetail">

      {blogPosts && (
        <Helmet>
          <title>
            {blogPosts.meta_title || stripHtml(blogPosts.heading)}
          </title>
          <meta
            name="description"
            content={blogPosts.meta_description}
          />
          <meta
            name="keywords"
            content={keywords}
          />
          <link
            rel="canonical"
            href={canonicalUrl}
          />
          {/* <meta property="og:title" content={blogPosts.meta_title} />
          <meta property="og:description" content={blogPosts.meta_description} />
          <meta property="og:type" content="article" />
          <meta property="og:url" content={`https://bastionex.net/blog/${blogPosts.slug}`} />
          <meta property="og:image" content={`https://bastionex.net/uploads/${blogPosts.image}`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={blogPosts.meta_title} />
          <meta name="twitter:description" content={blogPosts.meta_description} />
          <meta name="twitter:image" content={`https://bastionex.net/uploads/${blogPosts.image}`} /> */}
        </Helmet>
      )}

      <div className="top">
        <div className="topfirst">
          <img
            src={
              blogPosts?.image
                ? `${environmentVariables?.apiUrlBlogs}uploads/files/${blogPosts?.image}`
                : authorimg
            }
            alt="error"
          />
        </div>

        <div className="topsecond">
          <div className="blog-meta">
            <div className="imagee">
              <img src={blogPosts?.image ? `${environmentVariables?.apiUrlBlogs}uploads/files/${blogPosts?.author?.profile_pic}` : footerimg} alt="error" />
            </div>
            <div className="textt">
              <h4>{blogPosts?.author?.name}</h4>
              <p>{blogPosts?.author?.tag}</p>
            </div>
          </div>
          <h5>{formatDate(blogPosts?.created_at) || "Unknown Date"}</h5>
        </div>
      </div>

      <div className="bottom">
        <div className="text-container">
          <div className="text">
            <h2 dangerouslySetInnerHTML={{ __html: blogPosts?.heading }} />
            <p dangerouslySetInnerHTML={{ __html: blogPosts?.description }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainDetail;
